import React from "react";
import img1 from "../../../images/LandingPageImage/e_commerce.webp";
import img2 from "../../../images/LandingPageImage/education.webp";
import img3 from "../../../images/LandingPageImage/healthcare.webp";
import img4 from "../../../images/LandingPageImage/hospitality_restaurant.webp";
import img5 from "../../../images/LandingPageImage/small_business.webp";
import img6 from "../../../images/LandingPageImage/logistics_delivery.webp";
import img7 from "../../../images/LandingPageImage/Chat2.png";
import img8 from "../../../images/LandingPageImage/Chat1.png";
import img9 from "../../../images/LandingPageImage/Chat6.png";
import img10 from "../../../images/LandingPageImage/Chat3.png";
import img11 from "../../../images/LandingPageImage/Chat4.png";
import img12 from "../../../images/LandingPageImage/Chat5.png";

const items = [
  {
    id: 1,
    title: "Hospitality & Restaurants",
    gradient: "linear-gradient(135deg, #BED5FD 0%, #5899DF 100%)",
    image: img4,
    iconColor: "#5899DF",
    iconImage: img7,
  },
  {
    id: 2,
    title: "Logistics & Delivery",
    gradient: "linear-gradient(135deg, #FFDFBE 0%, #FF6801 100%)",
    image: img6,
    iconColor: "#FF6801",
    iconImage: img8,
  },
  {
    id: 3,
    title: "Education & Coaching",
    gradient: "linear-gradient(135deg, #D4FFF3 0%, #25B894 100%)",
    image: img2,
    iconColor: "#25B894",
    iconImage: img9,
  },
  {
    id: 4,
    title: "E-Commerce",
    gradient: "linear-gradient(135deg, #FFFFE8 0%, #FFB84E 100%)",
    image: img1,
    iconColor: "#764ba2",
    iconImage: img10,
  },
  {
    id: 5,
    title: "Small Business",
    gradient: "linear-gradient(135deg, #FFEDE8 0%, #B24EFF 100%)",
    image: img5,
    iconColor: "#B24EFF",
    iconImage: img11,
  },
  {
    id: 6,
    title: "Healthcare & Wellness",
    gradient: "linear-gradient(135deg, #E8EFFF 0%, #4E60FF 100%)",
    image: img3,
    iconColor: "#4E60FF",
    iconImage: img12,
  },
];

const ForthSection = () => {
  return (
    <>
      <style>{`
        :root {
          /* increased container so cards occupy more horizontal space on wide screens */
          --container-max: 1200px;
          --card-radius: 18px;
          --accent-color: #9E104C;
          --section-side-pad: 2rem; /* side padding used across breakpoints */
        }

        .ws-section {
          padding: 4rem var(--section-side-pad);
          background: #ffffff;
          display: flex;
          justify-content: center;
        }

        /* allow container to grow on larger screens, reducing left/right whitespace */
        .ws-container {
          max-width: var(--container-max);
          width: 100%;
          margin: 0 auto;
          padding: 0; /* use section padding for sides to keep consistent spacing */
        }

        .ws-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .ws-title-main {
          font-size: 2.1rem;
          max-width: 720px;
          margin: 0 auto;
          font-weight: 700;
          color: var(--accent-color);
          line-height: 1.12;
        }

        .ws-header-text {
          max-width: 880px;
          margin: 0.75rem auto 0;
          text-align: center;
          font-size: 1.05rem;
          line-height: 1.6;
          color: #475569;
        }

        /* GRID */
        .ws-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
          justify-items: center;
          align-items: stretch;
          margin-top: 1.25rem;
        }

        .ws-item {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: 320px;
        }

        /* CARD */
        .ws-card {
          width: 100%;
          aspect-ratio: 15 / 10;
          position: relative;
          border-radius: var(--card-radius);
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.28s ease, box-shadow 0.28s ease;
          display: block;
          background-clip: border-box;
        }

        .ws-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 40px rgba(16,24,40,0.08);
        }

        .ws-card-bg {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }

        .ws-title-overlay {
          position: absolute;
          top: 18px;
          left: 18px;
          background: rgba(255,255,255,0.92);
          padding: 8px 14px;
          border-radius: 12px;
          z-index: 4;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 6px 18px rgba(16,24,40,0.06);
        }

        .ws-chat-icon {
          width: 28px;
          height: 28px;
          object-fit: contain;
        }

        .ws-overlay-text {
          font-size: 0.98rem;
          font-weight: 700;
          margin: 0;
          color: #111827;
          white-space: nowrap;
          display: inline-block;
          max-width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ws-image-wrapper {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 62%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          z-index: 2;
          pointer-events: none;
        }

        .ws-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center bottom;
          transition: transform 0.5s ease;
          transform-origin: center bottom;
          user-select: none;
          -webkit-user-drag: none;
        }

        .ws-card:hover .ws-img {
          transform: scale(1.04);
        }

        /* Large screens: reduce side whitespace by allowing container to grow */
        @media (min-width: 1200px) {
          .ws-container {
            max-width: var(--container-max); /* 1400px - bigger than before so sides reduce */
            padding: 0 var(--section-side-pad);
          }

          .ws-image-wrapper {
            height: 65%;
          }

          .ws-img {
            transform: scale(1.08);
          }

          .ws-card:hover .ws-img {
            transform: scale(1.13);
          }

          /* slightly increase card max-width so they fill more space on wide screens */
          .ws-item {
            max-width: 360px;
          }

          .ws-grid {
            gap: 1.75rem;
          }
        }

        /* Tablet */
        @media (max-width: 992px) {
          .ws-section {
            padding: 3rem var(--section-side-pad);
          }

          .ws-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
            justify-items: center;
          }

          .ws-item {
            max-width: 440px;
          }

          .ws-card {
            aspect-ratio: 14 / 9;
          }

          .ws-image-wrapper {
            height: 65%;
          }

          .ws-title-overlay {
            top: 16px;
            left: 16px;
            padding: 9px 12px;
            gap: 8px;
          }

          .ws-overlay-text {
            max-width: 200px;
            font-size: 0.96rem;
          }
        }

        /* Mobile */
        @media (max-width: 640px) {
          .ws-section {
            padding: 2.2rem 0.9rem;
          }

          .ws-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .ws-item {
            max-width: 100%;
            display: flex;
            justify-content: center;
          }

          .ws-card {
            width: 100%;
            aspect-ratio: 15 / 12;
            border-radius: 14px;
          }

          .ws-title-overlay {
            top: 14px;
            left: 14px;
            padding: 8px 10px;
            gap: 8px;
            background: rgba(255,255,255,0.96);
          }

          .ws-overlay-text {
            font-size: 0.95rem;
            max-width: 180px;
          }

          .ws-image-wrapper {
            height: 75%;
          }

          .ws-img {
            transform: none;
          }

          .ws-card:hover .ws-img {
            transform: none;
          }
        }

        @media (max-width: 420px) {
          .ws-title-main {
            font-size: 1.6rem;
          }

          .ws-header-text {
            font-size: 0.98rem;
            padding: 0 8px;
          }

          .ws-title-overlay {
            padding: 7px 9px;
          }

          .ws-overlay-text {
            font-size: 0.9rem;
            max-width: 140px;
          }

          .ws-image-wrapper {
            height: 75%;
          }
        }
      `}</style>

      <section className="ws-section">
        <div className="ws-container">
          <div className="ws-header">
            <h2 className="ws-title-main">
              Automated WhatsApp Messaging Made Easy for Every Business
            </h2>
            <p className="ws-header-text">
              AkaSoft helps your business reach customers instantly
              and effortlessly. Send personalized messages, engage leads, and
              boost conversions—all while saving time with smart automation
              designed for every WhatsApp-driven business.
            </p>
          </div>

          <div className="ws-grid">
            {items.map((item) => (
              <article key={item.id} className="ws-item">
                <div className="ws-card" aria-hidden="false">
                  <div
                    className="ws-card-bg"
                    style={{ background: item.gradient }}
                    aria-hidden="true"
                  />
                  <div
                    className="ws-title-overlay"
                    role="group"
                    aria-label={item.title}
                  >
                    <img
                      src={item.iconImage}
                      alt={`${item.title} icon`}
                      className="ws-chat-icon"
                    />
                    <p
                      className="ws-overlay-text"
                      style={{ color: item.iconColor }}
                    >
                      {item.title}
                    </p>
                  </div>

                  <div className="ws-image-wrapper" aria-hidden="true">
                    <img src={item.image} alt={item.title} className="ws-img" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForthSection;
